import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { BoxContainer } from "../layouts/Theme";
import { useFlow } from "../context/FlowContext";
import { useI18N } from "../context/I18NContext";
import { useSettings } from "../context/SettingsContext";
import RegisterForm from "../partials/account/RegisterForm";
import SigninForm from "../partials/account/SigninForm";
import useWidgetStore from '../store/useWidgetStore';
export default function Register(props) {
    var _a, _b, _c, _d;
    const { t } = useI18N();
    const flow = useFlow();
    const { hasAccounts } = useSettings();
    const { consumer, isGuest, isLoginAccount } = useWidgetStore();
    useEffect(() => {
        if (!isGuest) {
            if (consumer.hash) {
                if (flow.onNext) {
                    flow.onNext();
                }
            }
        }
    }, []);
    return (_jsxs(BoxContainer, { id: "register-form", children: [hasAccounts && ((_b = (_a = flow.currentView) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.showLogin) && !isLoginAccount && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", component: "div", sx: { marginLeft: 1, flexGrow: 1 }, children: t('Bestaande klanten') }), _jsx(SigninForm, {}), _jsx(Typography, { variant: "h6", component: "div", sx: { marginLeft: 1, flexGrow: 1, my: 2 }, children: t('Of vul je persoonlijke gegevens in') })] })), _jsx(RegisterForm, { mode: "register", registerRequired: !!((_d = (_c = flow.currentView) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.registerRequired) })] }));
}
